import React, { useState } from 'react'
import { IoImageOutline } from 'react-icons/io5'

export default function SHGalleryFile({ fileName, img, onClick, bentoSize = 'small' }) {
    const [imageError, setImageError] = useState(false)

    const handleImageError = () => {
        setImageError(true)
    }

    return (
        <div className={`sh-gallery-file-card sh-gallery-item-${bentoSize}`} onClick={onClick}>
            {img && !imageError ? (
                <>
                    <img 
                        className='sh-gallery-file-image' 
                        src={img} 
                        alt={fileName}
                        onError={handleImageError}
                    />
                </>
            ) : (
                <div className='sh-gallery-file-image sh-gallery-file-placeholder'>
                    <IoImageOutline size={32} />
                    <span>No Preview</span>
                </div>
            )}
        </div>
    )
}
